export const BaseConfig = {
  DEFAULT_SUFFIX: ' - پی جیب',
  DEFAULT_TITLE: 'پی جیب',
}
